import { render, staticRenderFns } from "./ItemInfoSheet.vue?vue&type=template&id=20eb0bac&"
import script from "./ItemInfoSheet.vue?vue&type=script&lang=js&"
export * from "./ItemInfoSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports